import type { NewsItem } from '~/types/api/client/news'
export class WebsiteAPI {
    websiteId: number;
    clientId: number;
    constructor(websiteId: number, clientId: number) {
        this.websiteId = websiteId;
        this.clientId = clientId
    }

    async getNews(newsid?: number): Promise<NewsItem[]> {
        const response = await $fetch<NewsItem[]>(`/api/client/news`, {
            headers:useRequestHeaders(['cookie']),
            query: {
                clientid: this.clientId,
                websiteid: this.websiteId,
                newsid: newsid
            }
        }).catch(err => {
            switch(err.statusCode) {
                case 400:
                    return {status: 400, message: err.message}
                default:
                    return {status: 0, message: 'No idea man'}
            }
        })
        return response
    }
}